module.exports = __webpack_public_path__ + "static/media/icf.3463549e.jpg";